var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIconWithRound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02991 0 0 4.02991 0 9C0 13.9701 4.02991 18 9 18C13.9701 18 18 13.9701 18 9C18 4.02991 13.9701 0 9 0ZM12.8873 6.06094L8.65647 11.927C8.59734 12.0095 8.51939 12.0768 8.42908 12.1232C8.33876 12.1696 8.2387 12.1938 8.13717 12.1938C8.03563 12.1938 7.93557 12.1696 7.84525 12.1232C7.75494 12.0768 7.67699 12.0095 7.61786 11.927L5.11272 8.45558C5.03638 8.34911 5.11272 8.20045 5.2433 8.20045H6.18549C6.3904 8.20045 6.58527 8.29888 6.7058 8.46763L8.13616 10.4525L11.2942 6.07299C11.4147 5.90625 11.6076 5.8058 11.8145 5.8058H12.7567C12.8873 5.8058 12.9636 5.95446 12.8873 6.06094Z",
    fill: "#009959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIconWithRound);
export default __webpack_public_path__ + "static/media/rightIconWithRound.11535239a62d7d01c6e378516b3bd53a.svg";
export { ForwardRef as ReactComponent };